// extracted by mini-css-extract-plugin
export default {"error":"ImgTagFromContentTypeImage_error__ghBHo","image":"ImgTagFromContentTypeImage_image__Z4Ur1","clickable":"ImgTagFromContentTypeImage_clickable__-U0q1"};